import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js"

document.addEventListener('DOMContentLoaded', () => {

	flatpickr(".input-date", {
		altInput: true,
		allowInput: true,
		altFormat: "d.m.Y",
		dateFormat: "d.m.Y",
		wrap: true,
		locale: Russian,
		disableMobile: "true",
		onChange: (selectedDates, dateStr, instance) => {
			// Сообщить JustValidate, что поле обновлено
			const input = document.querySelector("#date-picker");
			input.dispatchEvent(new Event('input'));
		},
	});
})
